import React from "react";
import LabelToolTip from "../toolTipComponent/LabelToolTip";

const ProductNameOnPaymentScreen = (props) => {
  const { productName } = props;
  return (
    <LabelToolTip
      label={productName}
      labelLengthToShow={50}
      className="payment-cart-productname-with-tooltip"
    />
  );
};

export default ProductNameOnPaymentScreen;
